import { render, staticRenderFns } from "./fullName.vue?vue&type=template&id=40f21b76&"
import script from "./fullName.vue?vue&type=script&lang=js&"
export * from "./fullName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports